
import { type FC } from 'react';
import {
  ListMagnifyingGlass
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconListMagnifyingGlassProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconListMagnifyingGlass: FC<UiIconListMagnifyingGlassProps> = (props) => {
  return (
    <UiIcon
      IconComponent={ListMagnifyingGlass}
      {...props}
    />
  );
};
